<template>
  <div id="judge-case" class="listStyle">
    <!-- <div class="judge-empty">
      <van-empty description="升级维护中" />
    </div> -->
    <div id="goToHere2"></div>
    <!-- 搜索框 -->
    <SearchBox
      v-show="flag"
      ref="searchBox"
      @searchKeyWord="searchKeyWord"
      @changeCourt="changeCourt"
      @selectTime="selectTime"
      @clearTime="clearTime"
    ></SearchBox>
    <template v-if="$route.path =='/judgeCase'">
    <div class="search-wapper">
      <van-search v-model="court"
        show-action
        placeholder="选择或输入法院并搜索"
        @search="onSearch"
        @clear="onClear">
        <template #action>
          <div style="margin-left:10px" @click="onSearch">搜索</div>
        </template>
      </van-search>
      <div class="potence-box" @click="courtBtn">
        <div class="potence-title" >
          <div class="type-val">{{ typeValue !== "" ? typeText : "全部分类" }}</div>
          <span class="potence-sanjiao"></span>
        </div>
      </div>
    </div>
    </template>
    <!-- 展示 -->
    <van-popup v-model="showMatchingPop" position="bottom">
      <div class="court-div">
        <van-cell
          :title="item.name"
          v-for="item in filterCourts"
          :key="item.type"
          :style="court === item.name ? 'color:#7E6850' : ''"
          @click="chooseCourt(item.name)"
        ></van-cell>
      </div>
    </van-popup>
    <van-popup v-model="typePopShow" round position="bottom" 
      :style="{ height: '80%' }">
      <div style="text-align:center">
        <van-cell
          v-for="it in typeOptions"
          :title="it.text"
          :key="it.code"
          :style="typeValue === it.code ? 'color:#0084FF' : ''"
          @click="changeType(it.code)"
        ></van-cell>
        <van-cell 
          class="cell-cancel"
          title="取消" 
          @click="typePopShow = false" />
      </div>
    </van-popup>
    <!-- 列表组件 -->
      <list-content
        ref="listContent"
        :lists="lists"
        :total="total"
        :totalLists="totalLists"
      ></list-content>
    <!-- 分页 -->
    <div v-if="lists.length > 0" class="pageBoxStyle">
      <Pagination
        :currentPage="currentPage"
        :total="total"
        :totalLists="totalLists"
        @prevPage="prevPage"
        @nextPage="nextPage"
        @jumpToPageSize="jumpToPageSize"
      ></Pagination>
    </div>
    <!-- 底部导航 -->
    <Tabbar
      ref="tabbar"
      @alertCengji="alertCengji"
    ></Tabbar>
    <van-overlay :showLoding="showLoding"></van-overlay>
  </div>
</template>

<script>
import SearchBox from "@/components/common/search";
import ListContent from "@/components/common/listContent";
import Pagination from "@/components/common/pagination"; // 分页
import Tabbar from "@/components/common/tabbar";
import { commonToast,  warningNotify } from "@/utils/lib/toast.js";

export default {
  data() {
    return {
      currentType: 1,
      searchText: "",
      flag: true,
      currentPage: 1,
      total: 0,
      totalLists: 0, // 总的条数
      // 进度条
      showLoding: false,
      stime: "",
      etime: "",
      isFilter: false,
      SearchTimes: 1, // 查询次数
      lists: [],
      t1: [],
      t2: [],
      t3: [],
      courttype: 0,
      courtOptions: [],
      court: '', // 法院名称
      filterCourts: [],
      showMatchingPop: false, // 是否显示匹配法院弹窗
      typeOptions: [],
      typeValue: "",
      typeText: "全部分类",
      typePopShow: false
    }
  },
  components: {
    Tabbar,
    SearchBox,
    ListContent,
    Pagination
  },
  watch: {
    typeValue() {
      let temp = this.typeOptions.find((item) => {
        if (item.code === this.typeValue) {
          return item;
        }
      });
      console.log("改变val", temp);
      this.typeText = temp.text;
    }
  },
  created() {
    this.getCourt()
    this.getCaseType()
    this.getData()
  },
  
  methods: {
    // 获取法庭列表
    getCourt () {
      this.$http.reqGetCourt()
      .then((res) => {
        this.courtOptions = res.datas
      })
    },
    // 选择匹配的法院
    chooseCourt(val) {
      this.court = val
      this.showMatchingPop = false
      this.getData()
    },
    // 获取法院种类列表
    getCaseType () {
      this.$http.reqGetjudgeType()
      .then((res) => {

        res.datas.unshift({ code:"", expand: false, pptr:"", shortText:"", showSequence: 0, text:"全部分类" })

        this.typeOptions = res.datas
        //console.log('kkk', this.typeOptions)
      })
    },
    changeType(val) {
      this.typeValue = val;
      this.typePopShow = false
      this.getData();
    },
    // 打开选择法院弹窗
    courtBtn() {
      this.typePopShow = true;
    },
    // 确认搜索法院
    onSearch() {
      if (this.court) {
        this.filterCourts = this.courtOptions.filter(item => item.name.includes(this.court))
        console.log('fff', this.filterCourts)
        if(this.filterCourts.length > 0) {
          this.showMatchingPop = true
        }
        return
      }
      //this.filterCourts = Object.assign([], this.courtOptions)
      commonToast('您还未填写搜索关键词!', this);
      console.log('ggg', this.filterCourts)
    },
    // 取消搜索法院
    onClear () {
      this.court = ''
      this.getData()
    },
    // 点击弹出法规层级框
    alertCengji() {
      this.$refs.regulations.alertCengji();
    },
    // 改变法院类别
    changeCourt(val) {
      console.log("改变法院类别====", val);
      this.currentPage = 1;
      this.SearchTimes = 1;
      this.isFilter = false;
      this.courttype = val;
      this.getData();
    },
     // 恢复选择的状态
    backStatus() {
      this.$store.commit("choose/setFlag1", false);
    },
    
    // 选择时间
    selectTime(time) {
      this.stime = time.stime;
      this.etime = time.etime;
      this.currentPage = 1;
      this.getData()
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    // 清除时间按钮
    clearTime() {
      this.SearchTimes = 1;
      this.stime = '';
      this.etime = '';
      this.currentPage = 1;
      this.getData();
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    getData() {
      //111
      this.showLoding = true;
      let argsAnswer = {
        searchtimes: this.SearchTimes,
        frist: {
          text: this.searchText && this.searchText !== "" ? this.searchText : "",
          potence: "",
          icode: "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode
          },
          dirid: "",
          id: this.typeValue,
          stime: this.stime && this.stime !== "" ? this.stime : "",
          etime: this.etime && this.etime !== "" ? this.etime : "",
          court: this.court,
          courttype: this.courttype
        },
        second: [],
        fliter: {
          isfilter: this.isFilter,
          tagpc: [],
          tagid: "",
        },
        pager: [
          {
            pagesize: 10, // 每页显示的条数
            pageindex: this.currentPage, // 当前页
          },
        ],
        scencs: "paperword"
      };
      let nodes = this.$baseConfig.code;
      this.$http
        .reqGetGeneralFiles(argsAnswer, nodes)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              //console.log("3333335====》", response);
              this.showLoding = false;
              
              this.lists =
                response.tbls[0].items !== null ? response.tbls[0].items : [];

              this.total = Math.ceil(response.tbls[0].total / 10);
              this.totalLists = response.tbls[0].total; // 总的条数
              this.$store.commit(
                "search/setIsProtect",
                response.tbls[0].protect
              );
              this.$store.commit(
                "search/setWarningLevel",
                response.tbls[0].warninglevel
              );
              this.$store.commit(
                "search/setWarningText",
                response.tbls[0].warningtext
              );
              this.$store.dispatch("choose/updateLists", this.lists);

              // this.bus.$emit("classifytagData", this.data);
            } else {
              warningNotify(response.rltdesc, this);
              this.showLoding = false;
            }
          } else {
            warningNotify(response.rtndesc, this);
            this.showLoding = false;
          }
        })
        .catch((err) => {
          this.showLoding = false;
        });
    },
    // 搜索关键词
    searchKeyWord(keyword) {
      this.searchText = keyword;
      this.SearchTimes = 1;
      this.currentPage = 1;
      this.$refs.listContent.toggle([]);
      this.getData();
    },
    // 选择时间范围
    selectTime(time) {
      this.stime = time.stime;
      this.etime = time.etime;
      this.currentPage = 1;
      this.isFilter = false;

      this.SearchTimes = 1;
      this.$refs.listContent.toggle([]);
      this.getData();
    },
    // 点击上一页
    prevPage() {
      if (this.currentPage == 1) return;
      this.currentPage--;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      this.getData();
    },
    // 点击下一页
    nextPage() {
      if (this.currentPage == this.total) return;
      this.currentPage++;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      this.getData();
    },
    // 跳转到多少页
    jumpToPageSize(num) {
      this.currentPage = num;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      this.getData();
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";
#judge-case {
  // display: flex;
  // flex-direction: column;
  height:calc(100vh - 115px);
  overflow-y: auto;
  .judge-empty {
    height: 100%;
    /deep/.van-empty {
      height: 90%;
    }
  }
  .pageBoxStyle {
    width: 100%;
    position: fixed;
    bottom:2px;
    left: 0;
    font-size: 0.37333rem;
    flex: 0 0 50px;
    background-color: #fff;
  }
  .search-wapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    /deep/.van-search {
      width: 77%;
    }
    .potence-box {
      position: relative;
      display: flex;
      align-items: center;
      border-radius: 30px;
      height: 35px;
      margin-right: 11px;
      .potence-title {
        position: relative;
        margin-left: 10px;
        margin-right: 20px;
        .type-val {
          max-width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .potence-sanjiao {
          position: absolute;
          top: 8px;
          right: -16px;
          border: 6px solid transparent;
          border-top: 6px solid #333;
          border-radius: 4px;
        }
      }
    }
  }
  .cell-cancel {
    border-top: 10px solid #eaeaea;
  }
}
</style>